import { useEffect, useRef, useState } from "react";

import GuestImg        from "../../assets/images/conversations/ep-28-preeti-bajaj-guest.webp";
import ThumbImg        from "../../assets/images/conversations/028.webp";
import PlayIcon        from "../../assets/icons/conversations/play-icon.svg";
import PlayIcon2       from "../../assets/icons/conversations/play-icon-2.svg";
import ThumbImg2       from "../../assets/images/conversations/ep-28-preeti-bajaj-video2.webp";
import ThumbImg2Mobile from "../../assets/images/conversations/ep-28-preeti-bajaj-video2-mobile.webp";

/* ─────────────────────────────────────────────
   PREFIX: pb2-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .pb2-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .pb2-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ── HERO ── */
  .pb2-hero { padding-top: 60px; padding-bottom: 60px; }
  .pb2-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .pb2-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .pb2-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .pb2-hero__title.pb2-visible { opacity: 1; transform: translateY(0); }
  .pb2-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .pb2-hero__spotify.pb2-visible { opacity: 1; transform: translateY(0); }
  .pb2-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .pb2-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .pb2-hero__right.pb2-visible { opacity: 1; transform: translateY(0); }

  /* ── YOUTUBE THUMB (HERO) ── */
  .pb2-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .pb2-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .pb2-yt-thumb:hover img { opacity: 0.85; }
  .pb2-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .pb2-yt-thumb__play img { width: 40px; height: 44px; }
  .pb2-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .pb2-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  /* ── BODY ── */
  .pb2-body {
    padding-bottom: 60px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .pb2-body.pb2-visible { opacity: 1; transform: translateY(0); }
  .pb2-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .pb2-body__para:last-child { margin-bottom: 0; }

  /* ── VIDEO 2 ── */
  .pb2-video2 {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .pb2-video2.pb2-visible { opacity: 1; transform: translateY(0); }
  .pb2-video2__wrap {
    position: relative; width: 100%; height: 500px;
    border-radius: 12px; overflow: hidden;
  }
  .pb2-video2__wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }
  .pb2-video2__thumb {
    position: relative; width: 100%; height: 500px;
    border-radius: 12px; overflow: hidden;
    cursor: pointer; display: block; background: #000;
  }
  .pb2-video2__thumb--desktop,
  .pb2-video2__thumb--mobile {
    width: 100%; height: 100%; object-fit: cover;
    display: block; border-radius: 12px;
    transition: opacity 0.3s ease;
  }
  .pb2-video2__thumb:hover .pb2-video2__thumb--desktop,
  .pb2-video2__thumb:hover .pb2-video2__thumb--mobile { opacity: 0.85; }
  .pb2-video2__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .pb2-video2__play img { width: 60px; height: 60px; }

  /* show/hide mobile thumbnail */
  .pb2-video2__thumb--desktop { display: block; }
  .pb2-video2__thumb--mobile  { display: none; }

  /* ── GUEST ── */
  .pb2-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .pb2-guest.pb2-visible { opacity: 1; transform: translateY(0); }
  .pb2-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .pb2-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .pb2-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .pb2-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .pb2-inner { padding-left: 32px; padding-right: 32px; }
    .pb2-hero { padding-top: 32px; padding-bottom: 48px; }
    .pb2-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .pb2-hero__title { font-size: 24px; }
    .pb2-hero__left { gap: 16px; }
    .pb2-video2 { padding-bottom: 48px; }
    .pb2-video2__wrap { height: 350px; }
    .pb2-video2__thumb { height: 350px; }
    .pb2-video2__play img { width: 40px; height: 40px; }
    .pb2-guest__title { font-size: 24px; margin-bottom: 24px; }
    .pb2-guest__photo-bg { width: 260px; height: 300px; }
    .pb2-guest__name { font-size: 24px; margin-top: 18px; }
    .pb2-body__para { font-size: 14px; margin-bottom: 12px; }
    .pb2-body { padding-bottom: 48px; }
    .pb2-guest { padding-bottom: 48px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .pb2-inner { padding-left: 16px; padding-right: 16px; }
    .pb2-hero { padding-top: 51px; padding-bottom: 30px; }
    .pb2-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .pb2-hero__left { gap: 30px; }
    .pb2-hero__title { font-size: 30px; }
    .pb2-video2__wrap { height: 200px; }
    .pb2-video2__thumb { height: 200px; }
    .pb2-video2 { padding-bottom: 40px; }
    .pb2-video2__thumb--desktop { display: none; }
    .pb2-video2__thumb--mobile  { display: block; }
    .pb2-video2__play img { width: 30px; height: 30px; }
    .pb2-body__para { font-size: 16px; margin-bottom: 10px; }
    .pb2-guest__title { font-size: 30px; margin-bottom: 20px; text-align: left; }
    .pb2-guest__photo-bg { width: 100%; height: 386px; }
    .pb2-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .pb2-body { padding-bottom: 30px; }
    .pb2-guest { padding-bottom: 30px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("pb2-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const HERO_VIDEO_ID = "f_kqnSIZiWg";
const VIDEO2_ID     = "fsZYhp0j8gw";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="pb2-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${HERO_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 28 Preeti Bajaj"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div
      className="pb2-yt-thumb"
      onClick={() => setPlaying(true)}
      role="button"
      aria-label="Play video"
    >
      <img src={ThumbImg} alt="EP 28 Preeti Bajaj thumbnail" />
      <div className="pb2-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="pb2-hero">
      <div className="pb2-inner">
        <div className="pb2-hero__grid">
          <div className="pb2-hero__left">
            <h1 ref={titleRef} className="pb2-hero__title">
              EP 28 | Uncovering India's Clean Energy Transition | Preeti Bajaj | Luminous Power Technologies
            </h1>
            <div ref={spotifyRef} className="pb2-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/1z1LiDCTkTnxH2LxVR9ZEB?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 28 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="pb2-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="pb2-body">
      <div className="pb2-inner">
        <p className="pb2-body__para">
          So far, our program has focused relentlessly on the clean mobility sector in India. So, for this episode, we decide to take a break and concentrate on the clean energy sector in India instead. Today, we feature a conversation with the CEO one of Schneider Electric's companies in India which proved incredibly refreshing, not only because we spoke about the energy transition that we are all witnessing across our daily lives and how Lithium would play a predominant role in future of static energy applications.
        </p>
        <p className="pb2-body__para">
          It was also refreshing because we had the privilege to speak with a global women leader of Indian origin who has spent the bulk of her career in leadership roles in North America and Australia and now is back in India on a new business and technological challenge. Today we speak with Preeti BAJAJ, CEO &amp; MD of Luminous Power Technologies (P) Ltd
        </p>
      </div>
    </section>
  );
}

function Video2Section() {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  useFadeUp(ref);
  return (
    <section ref={ref} className="pb2-video2">
      <div className="pb2-inner">
        {playing ? (
          <div className="pb2-video2__wrap">
            <iframe
              src={`https://www.youtube.com/embed/${VIDEO2_ID}?autoplay=1&rel=0`}
              title="EP 28 Preeti Bajaj Full Video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        ) : (
          <div
            className="pb2-video2__thumb"
            onClick={() => setPlaying(true)}
            role="button"
            aria-label="Play video"
          >
            <img
              className="pb2-video2__thumb--desktop"
              src={ThumbImg2}
              alt="EP 28 Preeti Bajaj video"
            />
            <img
              className="pb2-video2__thumb--mobile"
              src={ThumbImg2Mobile}
              alt="EP 28 Preeti Bajaj video mobile"
            />
            <div className="pb2-video2__play">
              <img src={PlayIcon2} alt="Play" />
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="pb2-guest">
      <div className="pb2-inner">
        <h2 className="pb2-guest__title">Our Guest</h2>
        <div>
          <div className="pb2-guest__photo-bg">
            <img src={GuestImg} alt="Preeti Bajaj" />
          </div>
          <p className="pb2-guest__name">Preeti BAJAJ</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep28PreetiBajaj() {
  return (
    <>
      <style>{CSS}</style>
      <div className="pb2-page">
        <HeroSection />
        <BodySection />
        {/* <Video2Section /> */}
        <GuestSection />
      </div>
    </>
  );
}